// @flow

export {default as extractJson} from './extractJson';
